/**
 * @file AdUnitMediumRectangleSlot.tsx
 *
 * @fileoverview Renders custom ad banner.
 */

import React from 'react';

interface AdUnitMediumRectangleSlotProps {
  /**
   * Position index in the rendered list.
   */
  listIndex?: number;
}

export const AdUnitMediumRectangleSlot = ({
  listIndex,
}: AdUnitMediumRectangleSlotProps) => {
  return <></>;
};

export default AdUnitMediumRectangleSlot;
